import { ref, computed } from 'vue'
import type { Light } from '@/stores/lights'

export function useLightSelection() {
  const selectedItems = ref<Light[]>([])

  const isSelected = (item: Light) => {
    return selectedItems.value.some(selected => selected.id === item.id)
  }

  const selectItem = (item: Light) => {
    if (!isSelected(item)) {
      selectedItems.value.push(item)
    }
  }

  const deselectItem = (item: Light) => {
    const index = selectedItems.value.findIndex(selected => selected.id === item.id)
    if (index !== -1) {
      selectedItems.value.splice(index, 1)
    }
  }

  const toggleItem = (item: Light) => {
    if (isSelected(item)) {
      deselectItem(item)
    } else {
      selectItem(item)
    }
  }

  const clearSelection = () => {
    selectedItems.value = []
  }

  const selectOnly = (item: Light) => {
    selectedItems.value = [item]
  }

  const selectedCount = computed(() => selectedItems.value.length)

  return {
    selectedItems,
    selectedCount,
    isSelected,
    selectItem,
    deselectItem,
    toggleItem,
    clearSelection,
    selectOnly
  }
}
